import React from 'react'

export default function SobrietyCheckup(props) {
  const { submissions } = props
  
  return (
    <div>
      <h5 className="profile-header pt-4">Sobriety Checkup</h5>
      <div className="row">
        <div className="col-12 p-4">
          <table className="table table-sm table-responsive">
            <thead>
              <tr>
                <th className="col-6">Date Submitted</th>
                <th className="col-6">Have you used in the past 30 days?</th>
                <th className="col-6">Are you abstinent from all drugs and alcohol?</th>
              </tr>
            </thead>
            <tbody>
              {
                submissions.map((submission, index)=>(
                  <tr key={index}>
                    <td>{ moment(submission.created_at).format("MM/DD/YYYY @ h:mmA") }</td>
                    <td>{ submission.responses[0].bool ? 'Yes' : 'No' }</td>
                    <td>{ submission.responses[1].bool ? 'Yes' : 'No' }</td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
